import * as React from 'react';

import { Page, PageContent, PageHeader } from '../components/common';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import authActions from '../auth/authActions';

const qs = require('qs');

interface Props {
	currentUser: UserDetails;
	actions: any;
	history: any;
	location: any;
}
class FourOhOnePage extends React.Component<Props, {}> {
	componentWillMount() {
		
		const queryString = this.props.location.search[0] === '?' 
		? this.props.location.search.slice(1) 
		: this.props.location.search;

		const parsed = qs.parse(queryString);
		const url: string = parsed.redirect ? parsed.redirect : '/';

		if (this.props.currentUser.isAuthenticated) {
			this.props.history.push(url);
		}
		else if (url.startsWith('/admin')) {
			this.props.actions.loginAdmin();
		}
		else {
			this.props.actions.login();
		}
	}
	render() {
		return (
			<Page className="401 text-center" title="Unauthenticated">
				<PageContent>
					<PageHeader isCentered={true}>
						<h1 className="display-1 text-secondary">401</h1>
						<h2 className="text-secondary mb-0">Unauthenticated</h2>
					</PageHeader>
					<p className="mt-4">Redirecting you to the login page.</p>
				</PageContent>
			</Page>
		);
	}
}

function mapStateToProps(state: any) {
	return {
		currentUser: state.auth.currentUser
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...authActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(FourOhOnePage);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/401Page.tsx